import type { NotificationEntityType } from '@enterprise/api';
import { isNotDefined } from '@enterprise/core';

/**
 * Resolves a deep-link route for a notification entity.
 *
 * - `mailing` → Package Manager
 * - `mailinglist` → List Manager
 * - `recipient` → `null` (no-op, dormant per umbrella §7.7)
 * - `null` → `null`
 *
 * @param entityType - The type of entity.
 * @param entityId - The entity identifier.
 * @returns The route string, or `null` if no route is defined.
 */
export const resolveEntityRoute = (
  entityType: NotificationEntityType | null,
  entityId: null | number
): null | string => {
  if (isNotDefined(entityType) || isNotDefined(entityId)) {
    return null;
  }

  if (entityType === 'mailing') {
    return '/datastream/packagemanager';
  }

  if (entityType === 'mailinglist') {
    return '/datastream/listmanager';
  }

  // recipient: no-op — dormant per umbrella §7.7
  return null;
};
